import * as React from "react";
import * as styles from "./hero.module.css";

const HeroBackground = () => {
    return (
        <svg viewBox="0 0 1920 910" fill="none" xmlns="http://www.w3.org/2000/svg" className={styles.hero__background}>
            <g opacity="0.3" clipPath="url(#clip0_170_3393)">
                <mask
                    id="mask0_170_3393"
                    style={{maskType: "alpha"}}
                    maskUnits="userSpaceOnUse"
                    x="-932"
                    y="0"
                    width="3784"
                    height="1596"
                >
                    <rect width="1920" height="1596" transform="translate(-2)" fill="url(#paint0_radial_170_3393)" />
                </mask>
                <g mask="url(#mask0_170_3393)">
                    <g clipPath="url(#clip1_170_3393)">
                        <mask id="path-3-inside-1_170_3393" fill="white">
                            <path d="M-147 0H1V148H-147V0Z" />
                        </mask>
                        <path
                            d="M1 148V149.54H2.53969V148H1ZM1 0H-0.539688V148H1H2.53969V0H1ZM1 148V146.46H-147V148V149.54H1V148Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-3-inside-1_170_3393)"
                        />
                        <mask id="path-5-inside-2_170_3393" fill="white">
                            <path d="M1 0H149V148H1V0Z" />
                        </mask>
                        <path
                            d="M149 148V149.54H150.54V148H149ZM149 0H147.46V148H149H150.54V0H149ZM149 148V146.46H1V148V149.54H149V148Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-5-inside-2_170_3393)"
                        />
                        <mask id="path-7-inside-3_170_3393" fill="white">
                            <path d="M149 0H297V148H149V0Z" />
                        </mask>
                        <path
                            d="M297 148V149.54H298.54V148H297ZM297 0H295.46V148H297H298.54V0H297ZM297 148V146.46H149V148V149.54H297V148Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-7-inside-3_170_3393)"
                        />
                        <mask id="path-9-inside-4_170_3393" fill="white">
                            <path d="M297 0H445V148H297V0Z" />
                        </mask>
                        <path
                            d="M445 148V149.54H446.54V148H445ZM445 0H443.46V148H445H446.54V0H445ZM445 148V146.46H297V148V149.54H445V148Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-9-inside-4_170_3393)"
                        />
                        <mask id="path-11-inside-5_170_3393" fill="white">
                            <path d="M445 0H593V148H445V0Z" />
                        </mask>
                        <path
                            d="M593 148V149.54H594.54V148H593ZM593 0H591.46V148H593H594.54V0H593ZM593 148V146.46H445V148V149.54H593V148Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-11-inside-5_170_3393)"
                        />
                        <mask id="path-13-inside-6_170_3393" fill="white">
                            <path d="M593 0H741V148H593V0Z" />
                        </mask>
                        <path
                            d="M741 148V149.54H742.54V148H741ZM741 0H739.46V148H741H742.54V0H741ZM741 148V146.46H593V148V149.54H741V148Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-13-inside-6_170_3393)"
                        />
                        <mask id="path-15-inside-7_170_3393" fill="white">
                            <path d="M741 0H889V148H741V0Z" />
                        </mask>
                        <path
                            d="M889 148V149.54H890.54V148H889ZM889 0H887.46V148H889H890.54V0H889ZM889 148V146.46H741V148V149.54H889V148Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-15-inside-7_170_3393)"
                        />
                        <mask id="path-17-inside-8_170_3393" fill="white">
                            <path d="M889 0H1037V148H889V0Z" />
                        </mask>
                        <path
                            d="M1037 148V149.54H1038.54V148H1037ZM1037 0H1035.46V148H1037H1038.54V0H1037ZM1037 148V146.46H889V148V149.54H1037V148Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-17-inside-8_170_3393)"
                        />
                        <mask id="path-19-inside-9_170_3393" fill="white">
                            <path d="M1037 0H1185V148H1037V0Z" />
                        </mask>
                        <path
                            d="M1185 148V149.54H1186.54V148H1185ZM1185 0H1183.46V148H1185H1186.54V0H1185ZM1185 148V146.46H1037V148V149.54H1185V148Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-19-inside-9_170_3393)"
                        />
                        <mask id="path-21-inside-10_170_3393" fill="white">
                            <path d="M1185 0H1333V148H1185V0Z" />
                        </mask>
                        <path
                            d="M1333 148V149.54H1334.54V148H1333ZM1333 0H1331.46V148H1333H1334.54V0H1333ZM1333 148V146.46H1185V148V149.54H1333V148Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-21-inside-10_170_3393)"
                        />
                        <mask id="path-23-inside-11_170_3393" fill="white">
                            <path d="M1333 0H1481V148H1333V0Z" />
                        </mask>
                        <path
                            d="M1481 148V149.54H1482.54V148H1481ZM1481 0H1479.46V148H1481H1482.54V0H1481ZM1481 148V146.46H1333V148V149.54H1481V148Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-23-inside-11_170_3393)"
                        />
                        <mask id="path-25-inside-12_170_3393" fill="white">
                            <path d="M1481 0H1629V148H1481V0Z" />
                        </mask>
                        <path
                            d="M1629 148V149.54H1630.54V148H1629ZM1629 0H1627.46V148H1629H1630.54V0H1629ZM1629 148V146.46H1481V148V149.54H1629V148Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-25-inside-12_170_3393)"
                        />
                        <mask id="path-27-inside-13_170_3393" fill="white">
                            <path d="M1629 0H1777V148H1629V0Z" />
                        </mask>
                        <path
                            d="M1777 148V149.54H1778.54V148H1777ZM1777 0H1775.46V148H1777H1778.54V0H1777ZM1777 148V146.46H1629V148V149.54H1777V148Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-27-inside-13_170_3393)"
                        />
                        <mask id="path-29-inside-14_170_3393" fill="white">
                            <path d="M1777 0H1925V148H1777V0Z" />
                        </mask>
                        <path
                            d="M1925 148V149.54H1926.54V148H1925ZM1925 0H1923.46V148H1925H1926.54V0H1925ZM1925 148V146.46H1777V148V149.54H1925V148Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-29-inside-14_170_3393)"
                        />
                        <mask id="path-31-inside-15_170_3393" fill="white">
                            <path d="M-147 148H1V296H-147V148Z" />
                        </mask>
                        <path
                            d="M1 296V297.54H2.53969V296H1ZM1 148H-0.539688V296H1H2.53969V148H1ZM1 296V294.46H-147V296V297.54H1V296Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-31-inside-15_170_3393)"
                        />
                        <mask id="path-33-inside-16_170_3393" fill="white">
                            <path d="M1 148H149V296H1V148Z" />
                        </mask>
                        <path
                            d="M149 296V297.54H150.54V296H149ZM149 148H147.46V296H149H150.54V148H149ZM149 296V294.46H1V296V297.54H149V296Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-33-inside-16_170_3393)"
                        />
                        <mask id="path-35-inside-17_170_3393" fill="white">
                            <path d="M149 148H297V296H149V148Z" />
                        </mask>
                        <path d="M149 148H297V296H149V148Z" fill="black" fillOpacity="0.1" />
                        <path
                            d="M297 296V297.54H298.54V296H297ZM297 148H295.46V296H297H298.54V148H297ZM297 296V294.46H149V296V297.54H297V296Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-35-inside-17_170_3393)"
                        />
                        <mask id="path-37-inside-18_170_3393" fill="white">
                            <path d="M297 148H445V296H297V148Z" />
                        </mask>
                        <path
                            d="M445 296V297.54H446.54V296H445ZM445 148H443.46V296H445H446.54V148H445ZM445 296V294.46H297V296V297.54H445V296Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-37-inside-18_170_3393)"
                        />
                        <mask id="path-39-inside-19_170_3393" fill="white">
                            <path d="M445 148H593V296H445V148Z" />
                        </mask>
                        <path
                            d="M593 296V297.54H594.54V296H593ZM593 148H591.46V296H593H594.54V148H593ZM593 296V294.46H445V296V297.54H593V296Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-39-inside-19_170_3393)"
                        />
                        <mask id="path-41-inside-20_170_3393" fill="white">
                            <path d="M593 148H741V296H593V148Z" />
                        </mask>
                        <path
                            d="M741 296V297.54H742.54V296H741ZM741 148H739.46V296H741H742.54V148H741ZM741 296V294.46H593V296V297.54H741V296Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-41-inside-20_170_3393)"
                        />
                        <mask id="path-43-inside-21_170_3393" fill="white">
                            <path d="M741 148H889V296H741V148Z" />
                        </mask>
                        <path
                            d="M889 296V297.54H890.54V296H889ZM889 148H887.46V296H889H890.54V148H889ZM889 296V294.46H741V296V297.54H889V296Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-43-inside-21_170_3393)"
                        />
                        <mask id="path-45-inside-22_170_3393" fill="white">
                            <path d="M889 148H1037V296H889V148Z" />
                        </mask>
                        <path
                            d="M1037 296V297.54H1038.54V296H1037ZM1037 148H1035.46V296H1037H1038.54V148H1037ZM1037 296V294.46H889V296V297.54H1037V296Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-45-inside-22_170_3393)"
                        />
                        <mask id="path-47-inside-23_170_3393" fill="white">
                            <path d="M1037 148H1185V296H1037V148Z" />
                        </mask>
                        <path
                            d="M1185 296V297.54H1186.54V296H1185ZM1185 148H1183.46V296H1185H1186.54V148H1185ZM1185 296V294.46H1037V296V297.54H1185V296Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-47-inside-23_170_3393)"
                        />
                        <mask id="path-49-inside-24_170_3393" fill="white">
                            <path d="M1185 148H1333V296H1185V148Z" />
                        </mask>
                        <path
                            d="M1333 296V297.54H1334.54V296H1333ZM1333 148H1331.46V296H1333H1334.54V148H1333ZM1333 296V294.46H1185V296V297.54H1333V296Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-49-inside-24_170_3393)"
                        />
                        <mask id="path-51-inside-25_170_3393" fill="white">
                            <path d="M1333 148H1481V296H1333V148Z" />
                        </mask>
                        <path
                            d="M1481 296V297.54H1482.54V296H1481ZM1481 148H1479.46V296H1481H1482.54V148H1481ZM1481 296V294.46H1333V296V297.54H1481V296Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-51-inside-25_170_3393)"
                        />
                        <mask id="path-53-inside-26_170_3393" fill="white">
                            <path d="M1481 148H1629V296H1481V148Z" />
                        </mask>
                        <path d="M1481 148H1629V296H1481V148Z" fill="black" fillOpacity="0.1" />
                        <path
                            d="M1629 296V297.54H1630.54V296H1629ZM1629 148H1627.46V296H1629H1630.54V148H1629ZM1629 296V294.46H1481V296V297.54H1629V296Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-53-inside-26_170_3393)"
                        />
                        <mask id="path-55-inside-27_170_3393" fill="white">
                            <path d="M1629 148H1777V296H1629V148Z" />
                        </mask>
                        <path
                            d="M1777 296V297.54H1778.54V296H1777ZM1777 148H1775.46V296H1777H1778.54V148H1777ZM1777 296V294.46H1629V296V297.54H1777V296Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-55-inside-27_170_3393)"
                        />
                        <mask id="path-57-inside-28_170_3393" fill="white">
                            <path d="M1777 148H1925V296H1777V148Z" />
                        </mask>
                        <path
                            d="M1925 296V297.54H1926.54V296H1925ZM1925 148H1923.46V296H1925H1926.54V148H1925ZM1925 296V294.46H1777V296V297.54H1925V296Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-57-inside-28_170_3393)"
                        />
                        <mask id="path-59-inside-29_170_3393" fill="white">
                            <path d="M-147 296H1V444H-147V296Z" />
                        </mask>
                        <path
                            d="M1 444V445.54H2.53969V444H1ZM1 296H-0.539688V444H1H2.53969V296H1ZM1 444V442.46H-147V444V445.54H1V444Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-59-inside-29_170_3393)"
                        />
                        <mask id="path-61-inside-30_170_3393" fill="white">
                            <path d="M1 296H149V444H1V296Z" />
                        </mask>
                        <path
                            d="M149 444V445.54H150.54V444H149ZM149 296H147.46V444H149H150.54V296H149ZM149 444V442.46H1V444V445.54H149V444Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-61-inside-30_170_3393)"
                        />
                        <mask id="path-63-inside-31_170_3393" fill="white">
                            <path d="M149 296H297V444H149V296Z" />
                        </mask>
                        <path
                            d="M297 444V445.54H298.54V444H297ZM297 296H295.46V444H297H298.54V296H297ZM297 444V442.46H149V444V445.54H297V444Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-63-inside-31_170_3393)"
                        />
                        <mask id="path-65-inside-32_170_3393" fill="white">
                            <path d="M297 296H445V444H297V296Z" />
                        </mask>
                        <path
                            d="M445 444V445.54H446.54V444H445ZM445 296H443.46V444H445H446.54V296H445ZM445 444V442.46H297V444V445.54H445V444Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-65-inside-32_170_3393)"
                        />
                        <mask id="path-67-inside-33_170_3393" fill="white">
                            <path d="M445 296H593V444H445V296Z" />
                        </mask>
                        <path d="M445 296H593V444H445V296Z" fill="black" fillOpacity="0.1" />
                        <path
                            d="M593 444V445.54H594.54V444H593ZM593 296H591.46V444H593H594.54V296H593ZM593 444V442.46H445V444V445.54H593V444Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-67-inside-33_170_3393)"
                        />
                        <mask id="path-69-inside-34_170_3393" fill="white">
                            <path d="M593 296H741V444H593V296Z" />
                        </mask>
                        <path
                            d="M741 444V445.54H742.54V444H741ZM741 296H739.46V444H741H742.54V296H741ZM741 444V442.46H593V444V445.54H741V444Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-69-inside-34_170_3393)"
                        />
                        <mask id="path-71-inside-35_170_3393" fill="white">
                            <path d="M741 296H889V444H741V296Z" />
                        </mask>
                        <path
                            d="M889 444V445.54H890.54V444H889ZM889 296H887.46V444H889H890.54V296H889ZM889 444V442.46H741V444V445.54H889V444Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-71-inside-35_170_3393)"
                        />
                        <mask id="path-73-inside-36_170_3393" fill="white">
                            <path d="M889 296H1037V444H889V296Z" />
                        </mask>
                        <path
                            d="M1037 444V445.54H1038.54V444H1037ZM1037 296H1035.46V444H1037H1038.54V296H1037ZM1037 444V442.46H889V444V445.54H1037V444Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-73-inside-36_170_3393)"
                        />
                        <mask id="path-75-inside-37_170_3393" fill="white">
                            <path d="M1037 296H1185V444H1037V296Z" />
                        </mask>
                        <path
                            d="M1185 444V445.54H1186.54V444H1185ZM1185 296H1183.46V444H1185H1186.54V296H1185ZM1185 444V442.46H1037V444V445.54H1185V444Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-75-inside-37_170_3393)"
                        />
                        <mask id="path-77-inside-38_170_3393" fill="white">
                            <path d="M1185 296H1333V444H1185V296Z" />
                        </mask>
                        <path
                            d="M1333 444V445.54H1334.54V444H1333ZM1333 296H1331.46V444H1333H1334.54V296H1333ZM1333 444V442.46H1185V444V445.54H1333V444Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-77-inside-38_170_3393)"
                        />
                        <mask id="path-79-inside-39_170_3393" fill="white">
                            <path d="M1333 296H1481V444H1333V296Z" />
                        </mask>
                        <path d="M1333 296H1481V444H1333V296Z" fill="black" fillOpacity="0.1" />
                        <path
                            d="M1481 444V445.54H1482.54V444H1481ZM1481 296H1479.46V444H1481H1482.54V296H1481ZM1481 444V442.46H1333V444V445.54H1481V444Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-79-inside-39_170_3393)"
                        />
                        <mask id="path-81-inside-40_170_3393" fill="white">
                            <path d="M1481 296H1629V444H1481V296Z" />
                        </mask>
                        <path
                            d="M1629 444V445.54H1630.54V444H1629ZM1629 296H1627.46V444H1629H1630.54V296H1629ZM1629 444V442.46H1481V444V445.54H1629V444Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-81-inside-40_170_3393)"
                        />
                        <mask id="path-83-inside-41_170_3393" fill="white">
                            <path d="M1629 296H1777V444H1629V296Z" />
                        </mask>
                        <path
                            d="M1777 444V445.54H1778.54V444H1777ZM1777 296H1775.46V444H1777H1778.54V296H1777ZM1777 444V442.46H1629V444V445.54H1777V444Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-83-inside-41_170_3393)"
                        />
                        <mask id="path-85-inside-42_170_3393" fill="white">
                            <path d="M1777 296H1925V444H1777V296Z" />
                        </mask>
                        <path
                            d="M1925 444V445.54H1926.54V444H1925ZM1925 296H1923.46V444H1925H1926.54V296H1925ZM1925 444V442.46H1777V444V445.54H1925V444Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-85-inside-42_170_3393)"
                        />
                        <mask id="path-87-inside-43_170_3393" fill="white">
                            <path d="M-147 444H1V592H-147V444Z" />
                        </mask>
                        <path
                            d="M1 592V593.54H2.53969V592H1ZM1 444H-0.539688V592H1H2.53969V444H1ZM1 592V590.46H-147V592V593.54H1V592Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-87-inside-43_170_3393)"
                        />
                        <mask id="path-89-inside-44_170_3393" fill="white">
                            <path d="M1 444H149V592H1V444Z" />
                        </mask>
                        <path
                            d="M149 592V593.54H150.54V592H149ZM149 444H147.46V592H149H150.54V444H149ZM149 592V590.46H1V592V593.54H149V592Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-89-inside-44_170_3393)"
                        />
                        <mask id="path-91-inside-45_170_3393" fill="white">
                            <path d="M149 444H297V592H149V444Z" />
                        </mask>
                        <path
                            d="M297 592V593.54H298.54V592H297ZM297 444H295.46V592H297H298.54V444H297ZM297 592V590.46H149V592V593.54H297V592Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-91-inside-45_170_3393)"
                        />
                        <mask id="path-93-inside-46_170_3393" fill="white">
                            <path d="M297 444H445V592H297V444Z" />
                        </mask>
                        <path
                            d="M445 592V593.54H446.54V592H445ZM445 444H443.46V592H445H446.54V444H445ZM445 592V590.46H297V592V593.54H445V592Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-93-inside-46_170_3393)"
                        />
                        <mask id="path-95-inside-47_170_3393" fill="white">
                            <path d="M445 444H593V592H445V444Z" />
                        </mask>
                        <path
                            d="M593 592V593.54H594.54V592H593ZM593 444H591.46V592H593H594.54V444H593ZM593 592V590.46H445V592V593.54H593V592Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-95-inside-47_170_3393)"
                        />
                        <mask id="path-97-inside-48_170_3393" fill="white">
                            <path d="M593 444H741V592H593V444Z" />
                        </mask>
                        <path
                            d="M741 592V593.54H742.54V592H741ZM741 444H739.46V592H741H742.54V444H741ZM741 592V590.46H593V592V593.54H741V592Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-97-inside-48_170_3393)"
                        />
                        <mask id="path-99-inside-49_170_3393" fill="white">
                            <path d="M741 444H889V592H741V444Z" />
                        </mask>
                        <path
                            d="M889 592V593.54H890.54V592H889ZM889 444H887.46V592H889H890.54V444H889ZM889 592V590.46H741V592V593.54H889V592Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-99-inside-49_170_3393)"
                        />
                        <mask id="path-101-inside-50_170_3393" fill="white">
                            <path d="M889 444H1037V592H889V444Z" />
                        </mask>
                        <path d="M889 444H1037V592H889V444Z" fill="black" fillOpacity="0.1" />
                        <path
                            d="M1037 592V593.54H1038.54V592H1037ZM1037 444H1035.46V592H1037H1038.54V444H1037ZM1037 592V590.46H889V592V593.54H1037V592Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-101-inside-50_170_3393)"
                        />
                        <mask id="path-103-inside-51_170_3393" fill="white">
                            <path d="M1037 444H1185V592H1037V444Z" />
                        </mask>
                        <path
                            d="M1185 592V593.54H1186.54V592H1185ZM1185 444H1183.46V592H1185H1186.54V444H1185ZM1185 592V590.46H1037V592V593.54H1185V592Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-103-inside-51_170_3393)"
                        />
                        <mask id="path-105-inside-52_170_3393" fill="white">
                            <path d="M1185 444H1333V592H1185V444Z" />
                        </mask>
                        <path
                            d="M1333 592V593.54H1334.54V592H1333ZM1333 444H1331.46V592H1333H1334.54V444H1333ZM1333 592V590.46H1185V592V593.54H1333V592Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-105-inside-52_170_3393)"
                        />
                        <mask id="path-107-inside-53_170_3393" fill="white">
                            <path d="M1333 444H1481V592H1333V444Z" />
                        </mask>
                        <path
                            d="M1481 592V593.54H1482.54V592H1481ZM1481 444H1479.46V592H1481H1482.54V444H1481ZM1481 592V590.46H1333V592V593.54H1481V592Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-107-inside-53_170_3393)"
                        />
                        <mask id="path-109-inside-54_170_3393" fill="white">
                            <path d="M1481 444H1629V592H1481V444Z" />
                        </mask>
                        <path
                            d="M1629 592V593.54H1630.54V592H1629ZM1629 444H1627.46V592H1629H1630.54V444H1629ZM1629 592V590.46H1481V592V593.54H1629V592Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-109-inside-54_170_3393)"
                        />
                        <mask id="path-111-inside-55_170_3393" fill="white">
                            <path d="M1629 444H1777V592H1629V444Z" />
                        </mask>
                        <path d="M1629 444H1777V592H1629V444Z" fill="black" fillOpacity="0.1" />
                        <path
                            d="M1777 592V593.54H1778.54V592H1777ZM1777 444H1775.46V592H1777H1778.54V444H1777ZM1777 592V590.46H1629V592V593.54H1777V592Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-111-inside-55_170_3393)"
                        />
                        <mask id="path-113-inside-56_170_3393" fill="white">
                            <path d="M1777 444H1925V592H1777V444Z" />
                        </mask>
                        <path
                            d="M1925 592V593.54H1926.54V592H1925ZM1925 444H1923.46V592H1925H1926.54V444H1925ZM1925 592V590.46H1777V592V593.54H1925V592Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-113-inside-56_170_3393)"
                        />
                        <mask id="path-115-inside-57_170_3393" fill="white">
                            <path d="M-147 592H1V740H-147V592Z" />
                        </mask>
                        <path
                            d="M1 740V741.54H2.53969V740H1ZM1 592H-0.539688V740H1H2.53969V592H1ZM1 740V738.46H-147V740V741.54H1V740Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-115-inside-57_170_3393)"
                        />
                        <mask id="path-117-inside-58_170_3393" fill="white">
                            <path d="M1 592H149V740H1V592Z" />
                        </mask>
                        <path
                            d="M149 740V741.54H150.54V740H149ZM149 592H147.46V740H149H150.54V592H149ZM149 740V738.46H1V740V741.54H149V740Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-117-inside-58_170_3393)"
                        />
                        <mask id="path-119-inside-59_170_3393" fill="white">
                            <path d="M149 592H297V740H149V592Z" />
                        </mask>
                        <path
                            d="M297 740V741.54H298.54V740H297ZM297 592H295.46V740H297H298.54V592H297ZM297 740V738.46H149V740V741.54H297V740Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-119-inside-59_170_3393)"
                        />
                        <mask id="path-121-inside-60_170_3393" fill="white">
                            <path d="M297 592H445V740H297V592Z" />
                        </mask>
                        <path
                            d="M445 740V741.54H446.54V740H445ZM445 592H443.46V740H445H446.54V592H445ZM445 740V738.46H297V740V741.54H445V740Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-121-inside-60_170_3393)"
                        />
                        <mask id="path-123-inside-61_170_3393" fill="white">
                            <path d="M445 592H593V740H445V592Z" />
                        </mask>
                        <path
                            d="M593 740V741.54H594.54V740H593ZM593 592H591.46V740H593H594.54V592H593ZM593 740V738.46H445V740V741.54H593V740Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-123-inside-61_170_3393)"
                        />
                        <mask id="path-125-inside-62_170_3393" fill="white">
                            <path d="M593 592H741V740H593V592Z" />
                        </mask>
                        <path d="M593 592H741V740H593V592Z" fill="black" fillOpacity="0.1" />
                        <path
                            d="M741 740V741.54H742.54V740H741ZM741 592H739.46V740H741H742.54V592H741ZM741 740V738.46H593V740V741.54H741V740Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-125-inside-62_170_3393)"
                        />
                        <mask id="path-127-inside-63_170_3393" fill="white">
                            <path d="M741 592H889V740H741V592Z" />
                        </mask>
                        <path
                            d="M889 740V741.54H890.54V740H889ZM889 592H887.46V740H889H890.54V592H889ZM889 740V738.46H741V740V741.54H889V740Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-127-inside-63_170_3393)"
                        />
                        <mask id="path-129-inside-64_170_3393" fill="white">
                            <path d="M889 592H1037V740H889V592Z" />
                        </mask>
                        <path
                            d="M1037 740V741.54H1038.54V740H1037ZM1037 592H1035.46V740H1037H1038.54V592H1037ZM1037 740V738.46H889V740V741.54H1037V740Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-129-inside-64_170_3393)"
                        />
                        <mask id="path-131-inside-65_170_3393" fill="white">
                            <path d="M1037 592H1185V740H1037V592Z" />
                        </mask>
                        <path
                            d="M1185 740V741.54H1186.54V740H1185ZM1185 592H1183.46V740H1185H1186.54V592H1185ZM1185 740V738.46H1037V740V741.54H1185V740Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-131-inside-65_170_3393)"
                        />
                        <mask id="path-133-inside-66_170_3393" fill="white">
                            <path d="M1185 592H1333V740H1185V592Z" />
                        </mask>
                        <path
                            d="M1333 740V741.54H1334.54V740H1333ZM1333 592H1331.46V740H1333H1334.54V592H1333ZM1333 740V738.46H1185V740V741.54H1333V740Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-133-inside-66_170_3393)"
                        />
                        <mask id="path-135-inside-67_170_3393" fill="white">
                            <path d="M1333 592H1481V740H1333V592Z" />
                        </mask>
                        <path
                            d="M1481 740V741.54H1482.54V740H1481ZM1481 592H1479.46V740H1481H1482.54V592H1481ZM1481 740V738.46H1333V740V741.54H1481V740Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-135-inside-67_170_3393)"
                        />
                        <mask id="path-137-inside-68_170_3393" fill="white">
                            <path d="M1481 592H1629V740H1481V592Z" />
                        </mask>
                        <path
                            d="M1629 740V741.54H1630.54V740H1629ZM1629 592H1627.46V740H1629H1630.54V592H1629ZM1629 740V738.46H1481V740V741.54H1629V740Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-137-inside-68_170_3393)"
                        />
                        <mask id="path-139-inside-69_170_3393" fill="white">
                            <path d="M1629 592H1777V740H1629V592Z" />
                        </mask>
                        <path
                            d="M1777 740V741.54H1778.54V740H1777ZM1777 592H1775.46V740H1777H1778.54V592H1777ZM1777 740V738.46H1629V740V741.54H1777V740Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-139-inside-69_170_3393)"
                        />
                        <mask id="path-141-inside-70_170_3393" fill="white">
                            <path d="M1777 592H1925V740H1777V592Z" />
                        </mask>
                        <path
                            d="M1925 740V741.54H1926.54V740H1925ZM1925 592H1923.46V740H1925H1926.54V592H1925ZM1925 740V738.46H1777V740V741.54H1925V740Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-141-inside-70_170_3393)"
                        />
                        <mask id="path-143-inside-71_170_3393" fill="white">
                            <path d="M-147 740H1V888H-147V740Z" />
                        </mask>
                        <path
                            d="M1 888V889.54H2.53969V888H1ZM1 740H-0.539688V888H1H2.53969V740H1ZM1 888V886.46H-147V888V889.54H1V888Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-143-inside-71_170_3393)"
                        />
                        <mask id="path-145-inside-72_170_3393" fill="white">
                            <path d="M1 740H149V888H1V740Z" />
                        </mask>
                        <path
                            d="M149 888V889.54H150.54V888H149ZM149 740H147.46V888H149H150.54V740H149ZM149 888V886.46H1V888V889.54H149V888Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-145-inside-72_170_3393)"
                        />
                        <mask id="path-147-inside-73_170_3393" fill="white">
                            <path d="M149 740H297V888H149V740Z" />
                        </mask>
                        <path d="M149 740H297V888H149V740Z" fill="black" fillOpacity="0.1" />
                        <path
                            d="M297 888V889.54H298.54V888H297ZM297 740H295.46V888H297H298.54V740H297ZM297 888V886.46H149V888V889.54H297V888Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-147-inside-73_170_3393)"
                        />
                        <mask id="path-149-inside-74_170_3393" fill="white">
                            <path d="M297 740H445V888H297V740Z" />
                        </mask>
                        <path
                            d="M445 888V889.54H446.54V888H445ZM445 740H443.46V888H445H446.54V740H445ZM445 888V886.46H297V888V889.54H445V888Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-149-inside-74_170_3393)"
                        />
                        <mask id="path-151-inside-75_170_3393" fill="white">
                            <path d="M445 740H593V888H445V740Z" />
                        </mask>
                        <path
                            d="M593 888V889.54H594.54V888H593ZM593 740H591.46V888H593H594.54V740H593ZM593 888V886.46H445V888V889.54H593V888Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-151-inside-75_170_3393)"
                        />
                        <mask id="path-153-inside-76_170_3393" fill="white">
                            <path d="M593 740H741V888H593V740Z" />
                        </mask>
                        <path
                            d="M741 888V889.54H742.54V888H741ZM741 740H739.46V888H741H742.54V740H741ZM741 888V886.46H593V888V889.54H741V888Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-153-inside-76_170_3393)"
                        />
                        <mask id="path-155-inside-77_170_3393" fill="white">
                            <path d="M741 740H889V888H741V740Z" />
                        </mask>
                        <path
                            d="M889 888V889.54H890.54V888H889ZM889 740H887.46V888H889H890.54V740H889ZM889 888V886.46H741V888V889.54H889V888Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-155-inside-77_170_3393)"
                        />
                        <mask id="path-157-inside-78_170_3393" fill="white">
                            <path d="M889 740H1037V888H889V740Z" />
                        </mask>
                        <path
                            d="M1037 888V889.54H1038.54V888H1037ZM1037 740H1035.46V888H1037H1038.54V740H1037ZM1037 888V886.46H889V888V889.54H1037V888Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-157-inside-78_170_3393)"
                        />
                        <mask id="path-159-inside-79_170_3393" fill="white">
                            <path d="M1037 740H1185V888H1037V740Z" />
                        </mask>
                        <path d="M1037 740H1185V888H1037V740Z" fill="black" fillOpacity="0.1" />
                        <path
                            d="M1185 888V889.54H1186.54V888H1185ZM1185 740H1183.46V888H1185H1186.54V740H1185ZM1185 888V886.46H1037V888V889.54H1185V888Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-159-inside-79_170_3393)"
                        />
                        <mask id="path-161-inside-80_170_3393" fill="white">
                            <path d="M1185 740H1333V888H1185V740Z" />
                        </mask>
                        <path
                            d="M1333 888V889.54H1334.54V888H1333ZM1333 740H1331.46V888H1333H1334.54V740H1333ZM1333 888V886.46H1185V888V889.54H1333V888Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-161-inside-80_170_3393)"
                        />
                        <mask id="path-163-inside-81_170_3393" fill="white">
                            <path d="M1333 740H1481V888H1333V740Z" />
                        </mask>
                        <path
                            d="M1481 888V889.54H1482.54V888H1481ZM1481 740H1479.46V888H1481H1482.54V740H1481ZM1481 888V886.46H1333V888V889.54H1481V888Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-163-inside-81_170_3393)"
                        />
                        <mask id="path-165-inside-82_170_3393" fill="white">
                            <path d="M1481 740H1629V888H1481V740Z" />
                        </mask>
                        <path
                            d="M1629 888V889.54H1630.54V888H1629ZM1629 740H1627.46V888H1629H1630.54V740H1629ZM1629 888V886.46H1481V888V889.54H1629V888Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-165-inside-82_170_3393)"
                        />
                        <mask id="path-167-inside-83_170_3393" fill="white">
                            <path d="M1629 740H1777V888H1629V740Z" />
                        </mask>
                        <path
                            d="M1777 888V889.54H1778.54V888H1777ZM1777 740H1775.46V888H1777H1778.54V740H1777ZM1777 888V886.46H1629V888V889.54H1777V888Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-167-inside-83_170_3393)"
                        />
                        <mask id="path-169-inside-84_170_3393" fill="white">
                            <path d="M1777 740H1925V888H1777V740Z" />
                        </mask>
                        <path
                            d="M1925 888V889.54H1926.54V888H1925ZM1925 740H1923.46V888H1925H1926.54V740H1925ZM1925 888V886.46H1777V888V889.54H1925V888Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-169-inside-84_170_3393)"
                        />
                        <mask id="path-171-inside-85_170_3393" fill="white">
                            <path d="M-147 888H1V1036H-147V888Z" />
                        </mask>
                        <path d="M-147 888H1V1036H-147V888Z" fill="black" fillOpacity="0.1" />
                        <path
                            d="M1 1036V1037.54H2.53969V1036H1ZM1 888H-0.539688V1036H1H2.53969V888H1ZM1 1036V1034.46H-147V1036V1037.54H1V1036Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-171-inside-85_170_3393)"
                        />
                        <mask id="path-173-inside-86_170_3393" fill="white">
                            <path d="M1 888H149V1036H1V888Z" />
                        </mask>
                        <path
                            d="M149 1036V1037.54H150.54V1036H149ZM149 888H147.46V1036H149H150.54V888H149ZM149 1036V1034.46H1V1036V1037.54H149V1036Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-173-inside-86_170_3393)"
                        />
                        <mask id="path-175-inside-87_170_3393" fill="white">
                            <path d="M149 888H297V1036H149V888Z" />
                        </mask>
                        <path
                            d="M297 1036V1037.54H298.54V1036H297ZM297 888H295.46V1036H297H298.54V888H297ZM297 1036V1034.46H149V1036V1037.54H297V1036Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-175-inside-87_170_3393)"
                        />
                        <mask id="path-177-inside-88_170_3393" fill="white">
                            <path d="M297 888H445V1036H297V888Z" />
                        </mask>
                        <path
                            d="M445 1036V1037.54H446.54V1036H445ZM445 888H443.46V1036H445H446.54V888H445ZM445 1036V1034.46H297V1036V1037.54H445V1036Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-177-inside-88_170_3393)"
                        />
                        <mask id="path-179-inside-89_170_3393" fill="white">
                            <path d="M445 888H593V1036H445V888Z" />
                        </mask>
                        <path
                            d="M593 1036V1037.54H594.54V1036H593ZM593 888H591.46V1036H593H594.54V888H593ZM593 1036V1034.46H445V1036V1037.54H593V1036Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-179-inside-89_170_3393)"
                        />
                        <mask id="path-181-inside-90_170_3393" fill="white">
                            <path d="M593 888H741V1036H593V888Z" />
                        </mask>
                        <path
                            d="M741 1036V1037.54H742.54V1036H741ZM741 888H739.46V1036H741H742.54V888H741ZM741 1036V1034.46H593V1036V1037.54H741V1036Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-181-inside-90_170_3393)"
                        />
                        <mask id="path-183-inside-91_170_3393" fill="white">
                            <path d="M741 888H889V1036H741V888Z" />
                        </mask>
                        <path
                            d="M889 1036V1037.54H890.54V1036H889ZM889 888H887.46V1036H889H890.54V888H889ZM889 1036V1034.46H741V1036V1037.54H889V1036Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-183-inside-91_170_3393)"
                        />
                        <mask id="path-185-inside-92_170_3393" fill="white">
                            <path d="M889 888H1037V1036H889V888Z" />
                        </mask>
                        <path
                            d="M1037 1036V1037.54H1038.54V1036H1037ZM1037 888H1035.46V1036H1037H1038.54V888H1037ZM1037 1036V1034.46H889V1036V1037.54H1037V1036Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-185-inside-92_170_3393)"
                        />
                        <mask id="path-187-inside-93_170_3393" fill="white">
                            <path d="M1037 888H1185V1036H1037V888Z" />
                        </mask>
                        <path
                            d="M1185 1036V1037.54H1186.54V1036H1185ZM1185 888H1183.46V1036H1185H1186.54V888H1185ZM1185 1036V1034.46H1037V1036V1037.54H1185V1036Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-187-inside-93_170_3393)"
                        />
                        <mask id="path-189-inside-94_170_3393" fill="white">
                            <path d="M1185 888H1333V1036H1185V888Z" />
                        </mask>
                        <path
                            d="M1333 1036V1037.54H1334.54V1036H1333ZM1333 888H1331.46V1036H1333H1334.54V888H1333ZM1333 1036V1034.46H1185V1036V1037.54H1333V1036Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-189-inside-94_170_3393)"
                        />
                        <mask id="path-191-inside-95_170_3393" fill="white">
                            <path d="M1333 888H1481V1036H1333V888Z" />
                        </mask>
                        <path
                            d="M1481 1036V1037.54H1482.54V1036H1481ZM1481 888H1479.46V1036H1481H1482.54V888H1481ZM1481 1036V1034.46H1333V1036V1037.54H1481V1036Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-191-inside-95_170_3393)"
                        />
                        <mask id="path-193-inside-96_170_3393" fill="white">
                            <path d="M1481 888H1629V1036H1481V888Z" />
                        </mask>
                        <path
                            d="M1629 1036V1037.54H1630.54V1036H1629ZM1629 888H1627.46V1036H1629H1630.54V888H1629ZM1629 1036V1034.46H1481V1036V1037.54H1629V1036Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-193-inside-96_170_3393)"
                        />
                        <mask id="path-195-inside-97_170_3393" fill="white">
                            <path d="M1629 888H1777V1036H1629V888Z" />
                        </mask>
                        <path
                            d="M1777 1036V1037.54H1778.54V1036H1777ZM1777 888H1775.46V1036H1777H1778.54V888H1777ZM1777 1036V1034.46H1629V1036V1037.54H1777V1036Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-195-inside-97_170_3393)"
                        />
                        <mask id="path-197-inside-98_170_3393" fill="white">
                            <path d="M1777 888H1925V1036H1777V888Z" />
                        </mask>
                        <path d="M1777 888H1925V1036H1777V888Z" fill="black" fillOpacity="0.1" />
                        <path
                            d="M1925 1036V1037.54H1926.54V1036H1925ZM1925 888H1923.46V1036H1925H1926.54V888H1925ZM1925 1036V1034.46H1777V1036V1037.54H1925V1036Z"
                            fill="black"
                            fillOpacity="0.2"
                            mask="url(#path-197-inside-98_170_3393)"
                        />
                    </g>
                    <rect
                        x="-590.23"
                        y="0.769848"
                        width="3102.46"
                        height="2215.46"
                        stroke="black"
                        strokeOpacity="0.2"
                        strokeWidth="1.5397"
                    />
                </g>
            </g>
            <defs>
                <radialGradient
                    id="paint0_radial_170_3393"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(960 -0.000190258) rotate(90) scale(1596 1002.12)"
                >
                    <stop />
                    <stop offset="0.953125" stopOpacity="0" />
                </radialGradient>
                <clipPath id="clip0_170_3393">
                    <rect width="1920" height="1110" fill="white" />
                </clipPath>
                <clipPath id="clip1_170_3393">
                    <rect x="-591" width="3104" height="2217" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default HeroBackground;
